module.exports = __webpack_public_path__ + "img/body-desktop.13262621.svg";